import type { Link, MenuItem } from "../links";

/** Every whitespace-separated term must appear in the link's text. */
export function matchesQuery(section: MenuItem, link: Link, query: string): boolean {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;
  const haystack = [
    link.name,
    link.description,
    link.previously ?? "",
    section.header,
  ]
    .join(" ")
    .toLowerCase();
  return terms.every((term) => haystack.includes(term));
}

/** Sections holding at least one matching link, each trimmed to its matches. */
export function filterNavTree(tree: MenuItem[], query: string): MenuItem[] {
  if (query.trim() === "") return tree;
  return tree
    .map((section) => ({
      ...section,
      links: section.links.filter((link) => matchesQuery(section, link, query)),
    }))
    .filter((section) => section.links.length > 0);
}
